// extracted by mini-css-extract-plugin
export default {"ChooseMoreItemContainer":"ChooseMoreItemContainer_ChooseMoreItemContainer__As9eM"};